module.exports = __webpack_public_path__ + "static/media/monarch-on-black-eyed-susan-copy.21b923d0.jpg";